export class BpSelectorFrequencyModel {
	private _primaryFrequency: string = "";
	private _primaryName: string = "";
	private _secondaryDay: string = "";
	private _secondaryNumber: string = "";
	private _timeFrequency: string = "";

	public get primary(): string {
		return this._primaryFrequency;
	}

	public set primary(value: string) {
		this._primaryFrequency = value;
	}
	public get secondary(): string {
		return this._secondaryDay;
	}

	public get primaryName(): string {
		return this._primaryName;
	}

	public set primaryName(value: string) {
		this._primaryName = value;
	}

	public set secondary(value: string) {
		this._secondaryDay = value;
	}
	public get secondaryNumber(): string {
		return this._secondaryNumber;
	}

	public set secondaryNumber(value: string) {
		this._secondaryNumber = value;
	}
	public get time(): string {
		return this._timeFrequency;
	}

	public set time(value: string) {
		this._timeFrequency = value;
	}
}
